import { jsx as _jsx } from "react/jsx-runtime";
// Polyfills
import "es6-object-assign/auto";
import "core-js/fn/array/includes";
import "core-js/fn/promise/finally";
import "intl"; // For Safari 9
// import analytics from './scratch-gui/lib/analytics';
import AppStateHOC from "./scratch-gui/lib/app-state-hoc.jsx";
import BrowserModalComponent from "./scratch-gui/components/browser-modal/browser-modal.jsx";
import supportedBrowser from "./scratch-gui/lib/supported-browser";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import AppTarget from './scratch-gui/playground/render-gui'
//@ts-ignore
import styles from "./index.css";
// Register "base" page view
// analytics.pageview('/');
var Test = document.createElement("div");
Test.className = styles.app;
document.body.appendChild(Test);
if (supportedBrowser()) {
    // require needed here to avoid importing unsupported browser-crashing code
    // at the top level
    require("./Test").default(Test);
}
else {
    BrowserModalComponent.setAppElement(Test);
    var WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    var handleBack = function () { };
    // eslint-disable-next-line react/jsx-no-bind
    //@ts-ignore
    ReactDOM.render(_jsx(WrappedBrowserModalComponent, { onBack: handleBack }, void 0), 
    //@ts-ignore
    AppTarget);
}
